<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <span class="tip" slot="customerTypeTip">
        <el-tooltip class="custom-tooltip" placement="right">
          <div slot="content">
            <ul>
              <li>大客户：京东、顺丰、德邦、中通、极兔、申通;</li>
              <li>小客户（开票）正向：月结开票固定线路的;</li>
              <li>小客户（开票）逆向：返程月结开票的;</li>
              <li>散单（现金）：不开票收现金的；</li>
            </ul>
          </div>
          <i class="el-icon-question warning"></i>
        </el-tooltip>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {mapState} from 'vuex';


export default {
  data () {
    return {
      tmplData: null,
      baseForm: {
        stateOptions: [],
        orgIdOptions: [],
        customerTypeOptions: [],
        form: [
          {
            label: '客户编码',
            value: 'customerCode',
            type: 'input',
            disabled: true,
          },
          {
            label: '客户全称',
            value: 'companyName',
            type: 'input',
          },
          {
            label: '联系人',
            value: 'lineName',
            type: 'input',
          },
          {
            label: '联系手机',
            value: 'linePhone',
            type: 'input',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
          },
          {
            label: '客户类型',
            value: 'customerType',
            type: 'select',
          },
          {
            label: '公司地址',
            value: 'address',
            type: 'input',
          },
          {
            label: '客户状态',
            value: 'state',
            type: 'select',
            hide: !this.$route.query.id,
          },
        ],
        rules: {
          companyName: [ // 客户全称
            { required: true, message: '请输入客户全称', trigger: 'blur' },
          ],
          lineName: [ // 联系人
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          linePhone: [ // 联系手机
            { required: true, message: '请输入联系手机', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          orgId: [ // 归属部门
            { required: true, message: '请选择归属部门', trigger: 'blur' },
          ],
          customerType: [ // 客户类型
            { required: true, message: '请选择客户类型', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    getTmpl () {
      return this.tmplData;
    },

    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList({
        pid: this.userInfo.staffTFInfo.orgIds,
        isArchive: true,
      });
      const enumsList = await getEnumList({
        codeType: 'SYS_STATE_DESC',
      });
      const customerTypeList = await getEnumList({
        codeType: 'CUSTOMER_TYPE_NAME',
      });
      this.baseForm.customerTypeOptions = customerTypeList[0];
      this.baseForm.stateOptions = enumsList[0];
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      res.tmplData = this.tmplData;
      return res;
    },
    async init (data = {}) {
      if (data.state !== undefined || data.state !== null) {
        data.state = String(data.state);
      }
      this.$nextTick(() => {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: !this.$route.query.id,
          names: ['state', 'customerCode'],
        });
      });
      this.$refs.baseForm.setVal(data);
      if (data.tmplData) {
        this.tmplData = data.tmplData;
      } else {
        this.tmplData = await this.$refs.baseForm.getVal();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tip {
  margin-left: 16px;
  color: #999;
}
.custom-tooltip {
  white-space: pre-wrap; /* 允许文本换行 */
}
</style>
